import { useTranslation } from "react-i18next";
import { Text } from '@vds/core';
import { MarginSpacerL } from "common/components/styleTag";
import styled from "styled-components";

const OtherDeviceDetails = () => {
    const { t } = useTranslation(["byod"]);
    const otherDeviceDetails = t("byod.otherDeviceData", {
        ns: "byod",
        returnObjects: true,
    });

    return (
        <>
            <div>
                <Text kind="body" size="large">
                    <StyledSpan dangerouslySetInnerHTML={{
                        __html: otherDeviceDetails?.headerText,
                    }} /></Text>
                <MarginSpacerL />
               
            </div></>
    )
}
const StyledSpan = styled.span`
.header-container >div{
  padding-bottom:12px;
}
`
export default OtherDeviceDetails;